import React from 'react';
import styles from './SocialMedia.module.scss';

function SocialMedia() {
  return (
    <div className={styles.socialMedia}>
      {/* AVITO */}
      <a href="https://www.avito.ru/brands/grandnn/" target="noopener">
        <svg
          className={styles.icon}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_393_702)">
            <path
              d="M11.0468 17.5165C11.0464 16.2276 11.4296 14.9678 12.1473 13.8979C12.8651 12.828 13.8849 11.9966 15.0766 11.5096C16.2684 11.0227 17.578 10.9024 18.8383 11.1641C20.0986 11.4257 21.2525 12.0575 22.1527 12.9788C23.0528 13.9 23.6585 15.069 23.8923 16.3364C24.1261 17.6039 23.9774 18.9124 23.4653 20.0949C22.9532 21.2773 22.1009 22.2802 21.0171 22.9755C19.9333 23.6708 18.6672 24.0269 17.3804 23.9984C15.6864 23.9665 14.0729 23.2689 12.888 22.0562C11.7031 20.8436 11.0418 19.2131 11.0468 17.5165Z"
              fill="#DCDCDC"
            />
            <path
              d="M10.6285 5.29052C10.6347 6.34907 10.3255 7.3854 9.74037 8.26703C9.15527 9.14866 8.3209 9.83552 7.34392 10.2398C6.36694 10.6441 5.29175 10.7474 4.25583 10.5366C3.2199 10.3257 2.2703 9.8103 1.52844 9.05619C0.786577 8.30208 0.286167 7.34355 0.0911847 6.30316C-0.103798 5.26276 0.0155086 4.18777 0.433849 3.21563C0.85219 2.24349 1.55056 1.41837 2.43966 0.845763C3.32876 0.27316 4.3682 -0.0209083 5.42508 0.00115665C6.11358 0.0063104 6.79432 0.147214 7.42843 0.415823C8.06255 0.684431 8.63762 1.07548 9.12081 1.56665C9.604 2.05782 9.98584 2.63948 10.2445 3.27842C10.5032 3.91737 10.6337 4.60108 10.6285 5.29052Z"
              fill="#DCDCDC"
            />
            <path
              d="M17.5484 1.158C18.6509 1.15705 19.7087 1.59444 20.4892 2.37406C21.2698 3.15368 21.7093 4.21174 21.7112 5.31571C21.6867 6.37958 21.2652 7.39568 20.5298 8.16389C19.7944 8.93211 18.7984 9.39673 17.738 9.46626C17.1845 9.49463 16.631 9.41205 16.1098 9.22335C15.5886 9.03466 15.1103 8.74365 14.7029 8.3674C14.2955 7.99115 13.9673 7.53723 13.7374 7.03226C13.5075 6.52729 13.3806 5.98144 13.3642 5.42672C13.3416 4.86677 13.4338 4.30811 13.6351 3.78519C13.8363 3.26226 14.1424 2.78616 14.5344 2.38621C14.9264 1.98627 15.3961 1.67096 15.9145 1.45972C16.4329 1.24849 16.9889 1.1458 17.5484 1.158Z"
              fill="#DCDCDC"
            />
            <path
              d="M8.31474 17.5597C8.30623 18.1518 8.12275 18.7282 7.78745 19.216C7.45215 19.7038 6.98006 20.0813 6.43075 20.3007C5.88145 20.5201 5.27954 20.5717 4.701 20.4489C4.12246 20.3261 3.59321 20.0344 3.18005 19.6107C2.76688 19.1869 2.48832 18.6502 2.3795 18.0681C2.27069 17.486 2.33651 16.8846 2.56865 16.3399C2.8008 15.7953 3.18886 15.3316 3.68387 15.0076C4.17888 14.6836 4.75865 14.5136 5.35002 14.5192C5.74447 14.5225 6.13438 14.6039 6.49728 14.7587C6.86017 14.9135 7.18888 15.1388 7.46447 15.4214C7.74005 15.704 7.95706 16.0384 8.10299 16.4054C8.24892 16.7724 8.32088 17.1647 8.31474 17.5597Z"
              fill="#DCDCDC"
            />
          </g>
          <defs>
            <clipPath id="clip0_393_702">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
      {/* YOUTUBE */}
      <a
        href="https://www.youtube.com/channel/UCag1J-DthTzFd1j89EvRtKA"
        target="noopener"
      >
        <svg
          className={styles.icon}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_393_704)">
            <path
              d="M11.9486 20.6394C9.50452 20.4855 6.86559 20.3483 4.23937 20.1403C3.18643 20.0437 2.2029 19.5823 1.4649 18.8386C0.912215 18.2473 0.58063 17.4892 0.524541 16.6885C-0.0306587 13.3225 0.0166449 9.88711 0.664323 6.537C0.825213 5.79504 1.26543 5.14004 1.89695 4.70298C2.86272 3.96272 4.01487 3.77142 5.18397 3.66745C8.2954 3.38277 11.4223 3.29526 14.5452 3.40545C16.5233 3.48031 18.5014 3.65913 20.4754 3.86291C21.3321 3.98935 22.1242 4.38474 22.7331 4.98994C23.3229 5.56806 23.6846 6.33291 23.7539 7.14834C24.3141 10.5462 24.2654 14.0141 23.6099 17.3955C23.4479 18.1039 23.0275 18.7296 22.4281 19.1547C21.4837 19.8483 20.3374 20.2259 19.158 20.2318C16.8241 20.3774 14.4859 20.498 11.9486 20.6394ZM9.26732 16.4806L16.7775 11.9476L9.26732 7.42698V16.4806Z"
              fill="#DCDCDC"
            />
          </g>
          <defs>
            <clipPath id="clip0_393_704">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
      {/* Одноклассники */}
      <a href="https://ok.ru/group/53219034726616" target="noopener">
        <svg
          className={styles.icon}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_393_706)">
            <path
              d="M12.0091 12.3868C15.4584 12.3857 18.2524 9.61126 18.2513 6.1912C18.2502 2.77004 15.4529 -0.00110327 12.0046 3.29515e-07C8.55634 0.00110393 5.76124 2.77556 5.76235 6.19561C5.7668 9.61457 8.56191 12.3846 12.0091 12.3868ZM12.0091 3.63085C13.4378 3.63085 14.5961 4.77969 14.5961 6.19672C14.5961 7.61374 13.4378 8.76149 12.0091 8.76149C10.5803 8.76149 9.42202 7.61264 9.42202 6.19561C9.42425 4.77969 10.5815 3.63195 12.0091 3.63085ZM14.5338 17.4402C15.8189 17.1511 17.0451 16.6467 18.1612 15.9503C19.0113 15.4063 19.2561 14.2828 18.7075 13.4396C18.1679 12.6097 17.0574 12.3592 16.2095 12.8768C13.638 14.4715 10.3734 14.4715 7.80193 12.8768C6.94849 12.346 5.82133 12.5998 5.28389 13.4452C4.74423 14.2916 4.99793 15.4129 5.85248 15.9481C5.85359 15.9481 5.85471 15.9492 5.85471 15.9492C6.96963 16.6445 8.19583 17.1488 9.47989 17.4391L5.98823 20.9022C5.29279 21.6306 5.32506 22.7805 6.06056 23.4703C6.76712 24.1324 7.87092 24.1324 8.57748 23.4703L12.0068 20.0668L15.4384 23.4703C16.1528 24.1777 17.3088 24.1777 18.0232 23.4703C18.7364 22.7618 18.7364 21.6151 18.0232 20.9066L14.5338 17.4402Z"
              fill="#DCDCDC"
            />
          </g>
          <defs>
            <clipPath id="clip0_393_706">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
      {/* VK */}
      <a href="https://vk.com/jhgrand" target="noopener">
        <svg
          className={styles.icon}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.0277 7.93005C14.0701 8.86339 14.0955 9.80161 14.1718 10.7301C14.1872 10.8556 14.2277 10.9753 14.2903 11.0797C14.3528 11.184 14.4355 11.2701 14.5319 11.3311C14.6417 11.3354 14.751 11.3118 14.852 11.262C14.953 11.2122 15.0433 11.1373 15.1165 11.0428C16.362 9.47388 17.3432 7.65103 18.0099 5.66755C18.4336 4.49966 18.4717 4.46545 19.5605 4.46545C20.6492 4.46545 21.6532 4.46545 22.7038 4.46545C22.9536 4.46393 23.203 4.48681 23.4494 4.53386C23.907 4.62182 24.1146 4.96388 23.9366 5.45743C23.678 6.24299 23.356 6.99884 22.975 7.71504C22.2506 8.97578 21.4372 10.1583 20.6619 11.3898C20.5518 11.5608 20.4459 11.7416 20.3484 11.9273C19.9502 12.6945 19.9926 12.9926 20.5221 13.6425C21.4937 14.8381 22.4581 16.0402 23.4156 17.2488C23.5581 17.4409 23.6817 17.6507 23.7841 17.8743C24.2417 18.7636 23.9282 19.6041 23.0343 19.653C21.7888 19.7165 20.5348 19.653 19.2893 19.6139C18.9762 19.5893 18.6705 19.4932 18.3898 19.3313C18.1091 19.1695 17.859 18.9449 17.6541 18.6708C17.133 18.0453 16.6246 17.41 16.1078 16.7846C15.9352 16.5749 15.7467 16.3835 15.5444 16.2128C15.0233 15.7779 14.5785 15.9392 14.409 16.6673C14.265 17.2928 14.1803 17.9329 14.0871 18.5731C14.0728 18.8543 13.9638 19.1181 13.7834 19.308C13.6029 19.4979 13.3653 19.5989 13.1212 19.5895C9.54989 19.8778 6.80472 18.2115 4.69924 14.9472C2.86439 12.0321 1.32503 8.88414 0.111237 5.56493C-0.159891 4.85149 0.0688732 4.44102 0.75093 4.43613C1.84815 4.43613 2.94114 4.46545 4.03412 4.48011C4.30933 4.46737 4.58044 4.56022 4.80504 4.74413C5.02963 4.92804 5.19504 5.19263 5.27538 5.49652C5.88593 7.29222 6.71004 8.98125 7.72401 10.5151C7.90437 10.7866 8.1104 11.0341 8.33829 11.2529C8.72803 11.6243 9.04576 11.5119 9.15591 10.9353C9.27325 10.3942 9.3428 9.84086 9.36349 9.28364C9.36349 8.30632 9.3296 7.37786 9.29147 6.42009C9.29316 6.09781 9.19511 5.7854 9.01494 5.53906C8.83478 5.29273 8.58432 5.12863 8.30863 5.07627C7.85534 4.93456 7.77908 4.70489 8.14765 4.36772C8.40031 4.10328 8.71628 3.93296 9.05423 3.87906C10.3336 3.82693 11.613 3.82693 12.8924 3.87906C13.6888 3.87906 14.0235 4.29931 14.0659 5.21799C14.1082 6.13667 14.0659 7.02114 14.0659 7.92027L14.0277 7.93005Z"
            fill="#DCDCDC"
          />
        </svg>
      </a>
      {/* Telegram */}
      <a href="https://t.me/grand_gold_jewelry" target="noopener">
        <svg
          className={styles.icon}
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_393_710)">
            <path
              d="M22.0517 2.12913L0.78878 10.371C-0.0668675 10.7548 -0.356277 11.5234 0.581933 11.9406L6.03682 13.683L19.2259 5.48977C19.946 4.9754 20.6833 5.11257 20.0489 5.67837L8.72124 15.9878L8.3654 20.3508C8.69499 21.0244 9.29847 21.0275 9.68339 20.6927L12.8174 17.712L18.1848 21.752C19.4314 22.4939 20.1097 22.0151 20.3779 20.6554L23.8985 3.89903C24.264 2.22532 23.6407 1.48788 22.0517 2.12913Z"
              fill="#DCDCDC"
            />
          </g>
          <defs>
            <clipPath id="clip0_393_710">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </div>
  );
}

export { SocialMedia };
